module.exports = __webpack_public_path__ + "img/ic-attch.57d8b19c.svg";